import React, { Component } from "react";
import { Button } from "../components/Button";
import Input from "../components/Input";
import LimitedSelect from "../components/LimitedSelect";
import { FormattedMessage } from "react-intl";
import { refigerationOperatingRights as operatingRights } from "../constants";
import "./SearchForm.css";
import MunicipalitySelect from "../components/MunicipalitySelect";

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault();
    this.props.fetch(0);
  };

  render() {
    const {
      isFormValid,
      locale,
      searching,
      searchText,
      selectedMunicipalities,
      selectedOperatingRights,
      updateMunicipalities,
      updateOperatingRights,
      updateSearchText,
      resetForm,
    } = this.props;


    return (
      <form className='searchForm' onSubmit={this.submitForm}>
        <div className='searchControls'>
          <div className='searchInputContainer' style={{ paddingRight: 0 }}>
            <label>
              <FormattedMessage tagName='label' id='common.person' />
              <Input
                type='text'
                placeholder='refrigerationSearch.personSearchPlaceholder'
                value={searchText}
                onChange={updateSearchText}
              />
            </label>
          </div>
        </div>
        <div className='searchControls'>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.competencies' />
              <LimitedSelect
                onChange={updateOperatingRights}
                options={operatingRights[locale]}
                placeholder='refrigerationSearch.chooseCompetencies'
                value={selectedOperatingRights}
                maxSelections={5}
              />
            </label>
          </div>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.municipalities' />
              <MunicipalitySelect
                selectedMunicipalities={selectedMunicipalities}
                onChange={updateMunicipalities}
                maxSelections={5}
                locale={locale}
              />
            </label>
          </div>
        </div>
        <div className='searchButtonContainer'>
          <div className='validatorMessage' role='alert'>
            {!!!isFormValid() && <FormattedMessage id='refrigerationSearch.inputError' />}
          </div>
          <Button className='clearLink' onClick={resetForm}>
            <FormattedMessage id='common.clearForm' />
          </Button>
          <Button
            className='searchButton'
            type='submit'
            primary
            search
            disabled={searching || !isFormValid()}
          >
            <FormattedMessage id='common.search' />
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/RefrigerationSearch/SearchForm.js